<template>
  <div class="my-1" v-if="feedback">
    <div class="row m-1">
      <div class="col-12 mt-3">
        <div class="flex">
          <strong>Cliente:</strong>
          {{ feedback.customer }}
        </div>
        <div class="flex">
          <strong>Calificación:</strong>
          {{ feedback.restaurant_qualification }}
        </div>
        <div class="flex">
          <strong>Motivo:</strong>
          {{ feedback.tag_restaurant }}
        </div>
        <div class="flex">
          <strong>Comentario:</strong>
          {{ feedback.restaurant_comment }}
        </div>
      </div>
    </div>

    <div class="card mt-4">
      <el-table :data="itemsTable.items" row-key="id" header-row-class-name="thead-light"
        v-if="itemsTable.items.length !== 0" @sort-change="sortChange">
        <el-table-column v-for="column in itemsTable.columns" :key="column.label" v-bind="column">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>

import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import BackofficeApi from "../../gateways/backoffice-api";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
} from "element-ui";

export default {
  name: "starter-page",
  props: {
    feedback: {
      type: Object, // Specify the type of the prop
      required: false // If the prop is required or not
    }
  },
  components: {
    StatsCard,
    RouteBreadCrumb,
    flatPicker,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      orderDetails: null,
      itemsTable: {
        items: [],
        columns: [
          {
            prop: 'meal',
            label: 'Producto',
            minWidth: 150,
            sortable: true,
          },
          {
            prop: 'quantity',
            label: 'Cantidad',
            minWidth: 100,
            sortable: true,
          },
          {
            prop: 'note',
            label: 'Nota',
            minWidth: 200,
            sortable: true,
          },
        ],
      }
    };
  },
  computed: {
    host() {
      return process.env.VUE_APP_API_BACKOFFICE_URL.replace("/api/v1/", "");
    },
  },
  watch: {
    feedback: function (newVal, oldVal) {
      if (!newVal) {
        this.itemsTable.items = [];
        return;
      }
      if (newVal != oldVal) this.loadfeedbackDetails(newVal);
    }
  },
  methods: {
    close() {
      this.$emit('closeModal');
    },
    async loadfeedbackDetails(feedback) {
      this.itemsTable.items = feedback.items;
    },
    sortChange({ prop, feedback }) {
      if (prop) {
        this.itemsTable.items.sort((a, b) => {
          let aVal = a[prop]
          let bVal = b[prop]
          if (feedback === 'ascending') {
            return aVal > bVal ? 1 : -1
          }
          return bVal - aVal ? 1 : -1
        })
      } else {
        this.itemsTable.items.sort((a, b) => {
          return a.id - b.id
        })
      }
    },
  },
};
</script>
<style lang="scss">
.weight {
  width: 30%;
  border: 1px solid black;

  td,
  th,
  tr {
    border: 1px solid black;
  }
}
</style>
<style>
.noMargin {
  margin-bottom: 0rem;
}

.starter-page {
  min-height: calc(100vh - 380px);
}

.recipe img {
  max-width: 100%;
}

p {
  white-space: pre-line
}

@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }

  #print,
  #print * {
    visibility: visible;
  }

  #print {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
